'use strict';

angular.module('users')

.controller('AuthenticationController', ['$rootScope', '$scope', '$http', '$location', 'Authentication', 'EventTracker', 'Utilities', 'Users',
	function ($rootScope, $scope, $http, $location, Authentication, EventTracker, Utilities, Users) {
		$scope.authentication = Authentication;
		// If user is signed in then redirect back home
		if ($scope.authentication.user && $scope.authentication.user._id) location.href = '!/#/projects';

		$scope.credentials = {};
		$scope.termsConfirmed = false;
		$scope.error = '';
		$scope.info = '';

		// init sso data models
        $scope.ssoErr = null;
		$scope.ssoEmailOrDomain = null;

		$scope.processing = false;

		// Check if there is a message we want to display to the user
		var queryParameters = $location.search();
		if (queryParameters.hasOwnProperty('message')) {
			$scope.info = queryParameters.message;
		}
        if (queryParameters.hasOwnProperty('ssoEmailOrDomain')) {
            $scope.ssoEmailOrDomain = queryParameters.ssoEmailOrDomain;
        }
		if (queryParameters.hasOwnProperty('errorMessage')) {
			$scope.error = queryParameters.errorMessage;
		}
        if (queryParameters.hasOwnProperty('ssoErr')) {
            $scope.ssoErr = queryParameters.ssoErr;
        }
		if (queryParameters.hasOwnProperty('signup') && queryParameters.signup === 'true') {
			// Sends the user data to the analytics provider
			EventTracker.aliasUser();
			EventTracker.identifyUser();

			// Track the User creation
			var eventData = {};
			EventTracker.track('User Create Success', 'User Create', eventData);
			EventTracker.track('conversion', undefined, { 'send_to': 'AW-974751942/Z1miCPHwvXoQxpHm0AM' }, true);

			// Remove the no longer needed query parameter from url
			$location.search('signup', null);
		}

		$scope.signup = function() {

			if ($scope.termsConfirmed !== true) {
				Utilities.showMessage('Confirmation missing', 'Please confirm that you agree to the Privacy Policy and Terms of Service.', 'error');
				return;
			}

			$scope.processing = true;

			// We do not want to remove the user-name in the future. Till then
			// to not break anything we set automatically the username to the
			// email address
			$scope.credentials.username = $scope.credentials.email;

            Users.emailHasSSO({ email: $scope.credentials.username }).$promise
                .then(function (data) {
                    if(data.emailHasSSO === true) {
                        window.location.href = '/auth/sso?ssoEmailOrDomain=' + $scope.credentials.username;
                        return;
                    }

                    $http.post('/auth/signup', $scope.credentials).then(function(response) {
                        // If successful we assign the response to the global user model
                        $scope.authentication.user = response.data;

                        // Sends the user data to the analytics provider
                        EventTracker.aliasUser();
                        EventTracker.identifyUser();

                        // Track the User creation
                        var eventData = {};
                        EventTracker.track('User Create Success', 'User Create', eventData);
                        EventTracker.track('conversion', undefined, { 'send_to': 'AW-974751942/Z1miCPHwvXoQxpHm0AM' }, true);

                        // And redirect to the index page
                        //$location.path('/mobile-apps');
                        location.href = '!/#/projects';
                    }).catch(function(response) {
                        $scope.processing = false;
                        $scope.error = response.data.message;

                        // Track the User creation failed
                        var eventData = {
                            error_message: response.data.message
                        };
                        EventTracker.track('User Create Error', 'User Create', eventData);
                    });
                })
                .catch(function (error) {
                    $scope.error = error;
                });
		};

		$scope.signin = function() {
            Users.emailHasSSO({ email: $scope.credentials.username }).$promise
                .then(function (data) {
                    if(data.emailHasSSO === true) {
                        window.location.href = '/auth/sso?ssoEmailOrDomain=' + $scope.credentials.username;
                        return;
                    }

                    $http.post('/auth/signin', $scope.credentials).then(function(response) {
                        // If successful we assign the response to the global user model
                        $scope.authentication.user = response.data;

                        // Sends the user data to the analytics provider
                        EventTracker.identifyUser();

                        // Track the User login
                        var eventData = {};
                        EventTracker.track('User Login Success', 'User Login', eventData);

                        // And redirect to the index page
                        //$location.path('/mobile-apps');
                        location.href = '!/#/projects';
                        $rootScope.$broadcast('RefreshSignupStatus', null);
                    }).catch(function(response) {
                        $scope.error = response.data.message;

                        // Track the User login failed
                        var eventData = {
                            error_message: response.data.message
                        };
                        EventTracker.track('User Login Error', 'User login', eventData);
                    });
                })
                .catch(function (error) {
                    $scope.error = error;
                });

		};
		
		
		$scope.ssoSubmit = function () {
            window.location.href = '/auth/sso?ssoEmailOrDomain=' + $scope.ssoEmailOrDomain;
        };

		//Showing go-to-VueJS-version banner
		$(document).ready(() => {
	
		const showBanner = () => {
			setTimeout(() => {
			$('.go-to-vuejs-banner').addClass('on');
			$('.go-to-vuejs-banner').on('click', () => {
				let url = location.href.replace('#!', '!/#');

				location.href = url;
			});
			}, 750);
		};
	
		// Checking if there's any loader active
		// before showing the banner, so that the
		// animation is smoother
		const intervalId = window.setInterval(function(){
			if($('.spinner-wrapper').is(':visible')){
			return;
			} else {
			clearInterval(intervalId);
			showBanner();
			}
		}, 1000);
	
		});		
	}
])


/**
 * Directive which blocks links till user confirmed that he agrees to terms
 */
.directive('needsConfirmation', ['Utilities', function (Utilities) {
	return {
		restrict: 'A',
		scope: {
			needsConfirmation: '=',
		},
		link: function (scope, element, attributes) {
			element.on('click', function ($event) {
				if (scope.needsConfirmation !== true) {
					$event.preventDefault();
					Utilities.showMessage('Confirmation missing', 'Please confirm that you agree to the Privacy Policy and Terms of Service.', 'error');
					return false;
				}

				return true;
			});
		}
	};
}]);
